import { getFlagSvg } from '../Components/Common/Flag/Flag';
import { DropdownItemType, IDictionary } from '../types/common.type';
import { ReactComponent as USA } from '../assets/icons/Flags/USA.svg';
import { ReactComponent as AUS } from '../assets/icons/Flags/AUS.svg';

export const widthBreakPoint = 730;
export const maxPageNum = 8;
export const SPMaxPageNum = 3;

export const CUST_EMPTYFIELD_TEXT = '-';

export const NEWS_CATEGORY = [
  { value: 'Domestic News', label: 'Domestic news' },
  { value: 'ASX Announcements', label: 'ASX Announcements' },
  { value: 'Breaking Views', label: 'Breaking views' },
  { value: 'Macroeconomics', label: 'Macroeconomics' },
  { value: 'Politics', label: 'Politics' },
  { value: 'Equity', label: 'Equity' },
  { value: 'Debt/Fixed Income', label: 'Debt/Fixed Income' },
  { value: 'Forex', label: 'Forex' },
  { value: 'Commodities', label: 'Commodities' },
  { value: 'Energy', label: 'Energy' },
  { value: 'Technology', label: 'Technology' },
  { value: 'Real Estate', label: 'Real estate' },
];

export const NEWS_REIGON = ['Global'];

export const countryMenu: DropdownItemType[] = [
  { icon: <AUS />, label: 'Australia', value: 'AU' },
  { icon: <USA />, label: 'United States', value: 'US' },
];

export const recommendationInitalMenu: DropdownItemType[] = [
  { label: 'All (0)', value: '0' },
  { label: 'Strong buy (0)', value: '1' },
  { label: 'Buy (0)', value: '2' },
  { label: 'Hold (0)', value: '3' },
  { label: 'Reduce (0)', value: '4' },
  { label: 'Sell (0)', value: '5' },
];

export enum RECOMMENDATION_ENUM {
  ALL = '0',
  STRONG_BUY = '1',
  BUY = '2',
  HOLD = '3',
  REDUCE = '4',
  SELL = '5',
}

export const NEWS_DATE_FORMAT = 'YYYY-MM-DD';

export const THEME_COLOR_MAPPING: IDictionary<string> = {
  direct: '#D44500',
  potter: '#50BDB5',
  desktop: '#28ADE3',
};

export enum Currency {
  AU = 'AUD',
  US = 'USD',
}

export enum DRP {
  Y = 'Yes',
  N = 'No',
}
